if (!customElements.get('sub-collection-list')) {
  class SubCollectionList extends HTMLElement {
    static SCROLL_MQ = '(max-width: 1099.98px)';

    constructor() {
      super();
    }

    isScrollMode() {
      return window.matchMedia(SubCollectionList.SCROLL_MQ).matches;
    }

    connectedCallback() {
      this.selectors = {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      };

      this.classes = {
        grid: 'f-grid',
        swiper: 'swiper',
        swiperWrapper: 'swiper-wrapper',
      };

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);
      this.desktopList = this.querySelector('.wd-sub-collection-slider__items--desktop');
      this.mobileTrack = this.closest('.wd-sub-collection-slider')?.querySelector(
        '.wd-sub-collection-slider__track--mobile'
      );
      this.sliderWrapper = null;
      this.sliderInstance = false;

      this.scrollMql = window.matchMedia(SubCollectionList.SCROLL_MQ);
      this.onMqChange = this.onMqChange || this.init.bind(this);
      this.scrollMql.addEventListener('change', this.onMqChange);

      this.onFocusIn = this.onFocusIn || ((event) => {
        if (!this.sliderInstance?.slider) return;
        const slide = event.target.closest('.swiper-slide');
        if (!slide) return;
        this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
      });
      this.addEventListener('focusin', this.onFocusIn);

      if (Shopify.designMode && !this.onBlockSelect) {
        this.onBlockSelect = (e) => {
          if (e.detail.sectionId != this.sectionId) return;
          const { target } = e;
          const index = Number(target.dataset.index);
          const listRoot = this.isScrollMode() ? this.mobileTrack : this.desktopList;
          const slide = listRoot?.querySelector(`.wd-sub-collection-slider__slide[data-index="${index}"]`);
          if (!slide) return;

          if (this.sliderInstance?.slider) {
            this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
          } else {
            slide.scrollIntoView({ inline: 'start', block: 'nearest', behavior: 'instant' });
          }
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      this.init();
    }

    disconnectedCallback() {
      if (this.scrollMql && this.onMqChange) {
        this.scrollMql.removeEventListener('change', this.onMqChange);
      }
      if (this.onFocusIn) {
        this.removeEventListener('focusin', this.onFocusIn);
      }
      if (this.onBlockSelect) {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }
      this.destroySlider();
    }

    init() {
      this.sliderWrapper = this.desktopList;

      if (this.isScrollMode()) {
        this.destroySlider();
        requestAnimationFrame(() => this.scrollActiveToStart());
      } else {
        this.initSlider();
      }
    }

    scrollActiveToStart() {
      if (!this.isScrollMode() || !this.mobileTrack) return;

      const activeSlide = this.mobileTrack.querySelector('.wd-sub-collection-slider__item--active')?.closest(
        '.swiper-slide'
      );
      if (!activeSlide) return;

      activeSlide.scrollIntoView({ inline: 'start', block: 'nearest', behavior: 'instant' });
    }

    initSlider() {
      if (!this.sliderWrapper || this.isScrollMode()) return;

      const sliderOptions = {
        modules: [FoxTheme.Swiper.Navigation, FoxTheme.Swiper.Pagination, FoxTheme.Swiper.Mousewheel],
        slidesPerView: 'auto',
        spaceBetween: 0,
        navigation: false,
        pagination: false,
        loop: false,
        threshold: 2,
        mousewheel: {
          enabled: true,
          forceToAxis: true,
        },
      };

      if (typeof this.sliderInstance !== 'object') {
        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);

        this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
        this.sliderInstance.init();
      }
    }

    destroySlider() {
      this.classList.remove(this.classes.swiper);
      if (this.desktopList) {
        this.desktopList.classList.remove(this.classes.swiperWrapper);
        this.desktopList.classList.add(this.classes.grid);
      }
      if (typeof this.sliderInstance !== 'object') return;
      this.sliderInstance.slider.destroy();
      this.sliderInstance = false;
    }
  }

  customElements.define('sub-collection-list', SubCollectionList);
}
